/**
 * Created by WebStorm.
 * User: Mehedi Hasan
 * Date: 5/20/26
 * Time: 10:10 AM
 * Email: mdmehedihasanroni28@gmail.com
 */
import React, {createContext, useState} from "react";
import Notification from "../../components/common/Notification";
import {getErrorMessage} from "../../helpers/Utils";
import OtpService from "../../services/pms_services/OtpService";

export const PMSOtpContext = createContext("PMSOtpContext");

const PMSOtpContextProvider = ({ children }) => {

    const [otpSendLoading, setOtpSendLoading] = useState(false);
    const [otpVerifyLoading, setOtpVerifyLoading] = useState(false);
    const [resendOtpLoading, setResendLoading] = useState(false);

    const sendOtp = async data => {
        try {

            setOtpSendLoading(true);

            await OtpService.sendOtp(data);
            Notification("success", "Sent Otp", "Otp has been sent successfully.");

            setOtpSendLoading(false);

            return true;

        } catch (error) {

            setOtpSendLoading(false);

            Notification("error", "ERROR", getErrorMessage(error));

            return false;
        }
    };

    const verifyOtp = async data => {
        try {

            setOtpVerifyLoading(true);

            await OtpService.verifyOtp(data);
            Notification("success", "OTP Verified", "OTP has been verified successfully.");

            setOtpVerifyLoading(false);

            return true;

        } catch (error) {

            setOtpVerifyLoading(false);

            Notification("error", "ERROR", getErrorMessage(error));

            return false;
        }
    };

    const resendOtp = async data => {
        try {

            setResendLoading(true);

            await OtpService.resendOtp(data);
            Notification("success", "OTP Resend", "OTP has been resend successfully.");

            setResendLoading(false);

            return true;

        } catch (error) {

            setResendLoading(false);

            Notification("error", "ERROR", getErrorMessage(error));

            return false;
        }
    };

    return (
        <PMSOtpContext.Provider
            value={{
                sendOtp,
                otpSendLoading,
                verifyOtp,
                otpVerifyLoading,
                resendOtp,
                resendOtpLoading,
            }}
        >
            {children}
        </PMSOtpContext.Provider>
    );
};

export default PMSOtpContextProvider;
